import { state } from './state'
import actions from './actions'
import { stringToJSON } from '@/utils'

const mutations = {
  setIsLogin(state, data) {
    state.isLogin = data
  },
  setIsAdmin(state, data) {
    state.isAdmin = data
  },
  setUserInfo(state, data) {
    data.currentLevel = Math.min(10, data.currentLevel)
    state.userInfo = data
  },
  setTaskList(state, data) {
    state.taskList = { ...state.taskList, ...data } // 避免覆盖
  },
  setPalcodeInfo(state, data) {
    state.palcodeInfo = { ...state.palcodeInfo, ...data } // 避免覆盖
  },
  setMyThread(state, data) {
    state.myThread = data
  },
  setMyReply(state, data) {
    state.myReply = data
  },
  setMyDonate(state, data) {
    state.myDonate = data
  },
  setMyFavorite(state, data) {
    state.myFavorite = data
  },
  setMyPersonalNotice(state, data) {
    state.myPersonalNotice = data
  },
  setMySystemNotice(state, data) {
    state.mySystemNotice = data
  },
  setMemories(state, data) {
    state.memoriesInfo = data
  },
  changeNoticeStatus(state, data) {
    let type = data.type === 'post' ? 'myPersonalNotice' : 'mySystemNotice'
    if (data.id) {
      state[type].list.find(({ id }) => +id === +data.id).new = "0"
      if (state[type].unread > 0) state[type].unread--
    } else {
      state[type].list.forEach((el) => el.new = "0")
      state[type].unread = 0
    }
  },
}

const getters = {
  userId(state) {
    return state.userInfo?.uid || ''
  },
  userName(state) {
    return state.userInfo?.nickname || ''
  },
  palcodeBonus(state) {
    const palcodeSettings = {
      bonus: '', // '5000'
      description: '', // '2000'
      ...state.taskList.palcode[0]
    }
    return {
      beRecommender: palcodeSettings.bonus, // 推荐别人
      recommendedBy: stringToJSON(palcodeSettings.description, {})?.extcredit2 || '' // 被别人推荐
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
